<template>
  <div class="myInvest" :class="{ isiOSX: isiOSX }">
    <van-nav-bar class="invest-title" :fixed="true" :title="title" />
    <img
      @click="goBack()"
      class="invest-reback"
      src="../../assets/myInvest/reback.png"
    />
    <investItem v-if="tab[0] == 1" />
    <myInvest v-if="tab[1] == 1" />
    <myProfit v-if="tab[2] == 1" />
    <van-tabbar>
      <van-tabbar-item @click="project()">
        <span>众筹项目</span>
        <img
          slot="icon"
          src="../../assets/myInvest/tab1_1.png"
          v-if="tab[0] == 0"
        />
        <img
          slot="icon"
          src="../../assets/myInvest/tab1_2.png"
          v-if="tab[0] == 1"
        />
      </van-tabbar-item>
      <van-tabbar-item @click="myProject()">
        <span>我的众筹</span>
        <img
          slot="icon"
          src="../../assets/myInvest/tab2_1.png"
          v-if="tab[1] == 0"
        />
        <img
          slot="icon"
          src="../../assets/myInvest/tab2_2.png"
          v-if="tab[1] == 1"
        />
      </van-tabbar-item>
      <van-tabbar-item @click="myProfit()">
        <span>我的收益</span>
        <img
          slot="icon"
          src="../../assets/myInvest/tab3_1.png"
          v-if="tab[2] == 0"
        />
        <img
          slot="icon"
          src="../../assets/myInvest/tab3_2.png"
          v-if="tab[2] == 1"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import investItem from "./investItem.vue";
import myInvest from "./order.vue";
import myProfit from "./income.vue";
export default {
  components: {
    investItem,
    myInvest,
    myProfit,
  },
  data() {
    return {
      tab: [0, 0, 0],
      title: "",
      isiOSX: false,
      InvestTab: 0, //1,2,3为有效值
    };
  },
  created() {
    this.InvestTab = localStorage.getItem("investTab");

    if (this.$route.query.from || this.InvestTab == 3) {
      this.tab = [0, 0, 1];
      this.title = "我的收益";
    } else if (this.InvestTab) {
      if (this.InvestTab == 1) {
        this.tab = [1, 0, 0];
        this.title = "众筹项目";
      } else if (this.InvestTab == 2) {
        this.tab = [0, 1, 0];
        this.title = "我的众筹";
      }
    } else {
      this.tab = [1, 0, 0];
      this.title = "众筹项目";
    }
    this.$api.setToken(this.$route.query.token);
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    project() {
      this.tab = [1, 0, 0];
      this.title = "众筹项目";
      localStorage.setItem("investTab", 1);
    },
    myProject() {
      this.tab = [0, 1, 0];
      this.title = "我的众筹";
      localStorage.setItem("investTab", 2);
    },
    myProfit() {
      this.tab = [0, 0, 1];
      this.title = "我的收益";
      localStorage.setItem("investTab", 3);
    },
    goBack() {
      localStorage.removeItem("investTab");
      this.params("", "", "goBack");
    },
  },
};
</script>

<style lang="less">
.myInvest {
  background-color: #f2f2f2;
  height: 100%;
  .van-pull-refresh{
    height: auto;
  }
  .van-tabbar {
    height: 49px;
    box-shadow: 0 -1px 0 #eee;
    .van-tabbar-item {
      color: #333;
      font-size: 11px !important;
    }
  }
  .invest {
    &-title {
      z-index: 2 !important;
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 29px;
      left: 0;
      z-index: 2;
    }
  }
}
.isiOSX {
  .invest {
    &-title {
      padding-top: 44px;
    }
    &-reback {
      top: 49px;
    }
  }
}
</style>
